module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Foobar API is " + _vm._s(_vm.api) + " BTW "), (_vm.api === 'OK') ? _c('span', [_vm._v("... Thanks for asking ;-)")]) : _c('span', [_vm._v(":(")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45146c3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ApiCheck.vue
// module id = 1828
// module chunks = 1